import { Pipe, PipeTransform } from '@angular/core';
import { SigningStatusEnum } from 'app/main/signing-pages/enums/enum';
import { Observable } from 'rxjs';
import { ILabelValueConstant } from '../../constants/constants';
import { RecipientRole } from '../../main/pages/contacts/organizations/organizations.dto';
import { UserTimezone } from '../../main/signing-pages/signing-page/signing-page.dto';
import { MomentPipe } from '../moment.pipe';

@Pipe({
    name: 'indexDataPipe',
})

/**
 * return the inviation type svg
 */
export class IndexDataPipe implements PipeTransform {
   constructor(private _dateFormatePipe: MomentPipe) {}
    async transform(rolesData:  RecipientRole): Promise<ILabelValueConstant[]> {
        let detailsData = [];
        if(rolesData.recipient_role_detail.is_sender == 1) return detailsData;
        
        // Fetch the signed date asynchronously
        let signedDate = '';
        if (rolesData?.recipient_role_detail?.status === SigningStatusEnum.SIGNED) {
            signedDate = await this.getFormattedSignedDate(rolesData?.recipient_role_detail?.status_updated_at);
        }
        
        detailsData = [
            { label: 'Recipient Role', value: rolesData?.role_name },
            { label: 'Authentication', value: rolesData?.authentication_type },
            { label: 'Invitation type', value: rolesData?.invitation_type },
            { label: 'Invitation order', value: rolesData?.invitation_order },
            { label: 'Confirmation', value: rolesData?.confirmation_type },
            { label: 'Signed date', value: signedDate }
        ];
        return detailsData;
    }


    // Helper function to handle the async behavior of DateFormatPipe
    private async getFormattedSignedDate(date: string): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            (this._dateFormatePipe.transform(date, {} as UserTimezone) as Observable<string>).subscribe({
                next: (formattedDate) => resolve(formattedDate),
                error: (err) => reject(err)
            });
        });
    }
}
